import type { CancelForSupplyFailureInput } from '@repo/api-contracts';
import { trpc } from '@/shared/api';
import type { OrderRefundResult } from '@/shared/lib';
import { useRefreshAfterRefund } from './use-refresh-after-refund';

/**
 * 공급 불가 취소(orderManagement.cancelForSupplyFailure, 주문 설계 §6-4). 승인 결제(`paymentId`, 없으면 null)의 남은 금액 전액을 환불하고 결과(COMPLETED·UNKNOWN)를 돌려준다 —
 * 결과 문구는 환불 대화상자가 정한다. 결과와 함께 주문·결제 캐시를 갱신한다. 거절·처리 중은 결제 캐시만 갱신하고 서버 오류를 그대로 던진다.
 */
export const useSupplyFailureCancel = (
  paymentId: string | null,
): ((input: CancelForSupplyFailureInput) => Promise<OrderRefundResult>) => {
  const refresh = useRefreshAfterRefund(paymentId);
  const mutation = trpc.orderManagement.cancelForSupplyFailure.useMutation();

  return async (input) => {
    let result: OrderRefundResult;
    try {
      result = await mutation.mutateAsync(input);
    } catch (failure) {
      await refresh.afterFailure();
      throw failure;
    }
    await refresh.afterResult(input.orderId, result);
    return result;
  };
};
